import { render, staticRenderFns } from "./appImage.vue?vue&type=template&id=a8da245c&"
import script from "./appImage.vue.ts?vue&type=script&lang=ts&"
export * from "./appImage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports